export const ONBU025_EXPERIMENT_KEY = 'onbu-0025';
export const ONBU025_VARIANT_GROUP = 'variant';
export const ONBU025_CONTROL_GROUP = 'control';